import React from 'react';
import { useNavigate } from 'react-router';
import FavoriteIcon from 'assets/favorite-icon';

export function Empty() {
  const navigate = useNavigate();

  return (
    <div className="empty-favorites">
      <div className="empty-favorites__content">
        <div>
          <FavoriteIcon />
        </div>
        <h6 className="empty-favorites__title">Lista de favoritos vazia</h6>
        <p className="empty-favorites__description">
          Aqui ficam os seus produtos favoritos. Para adicionar, clique no ícone de estrela nos produtos desejados.
        </p>
      </div>
      <button
        className="btn-default-wl btn btn-primary text-xs empty-favorites__button"
        onClick={() => navigate('/loja')}
        type="button"
      >
        VOLTAR PARA HOME
      </button>
    </div>
  );
}